<template>
    <common-panel
            v-model="value"
            :image="image"
            :is-read-only="readOnly"
            :width-style="widthStyle"
            :related-url="relatedUrl"
            :validation-lists="validationLists"
            :translate-obj="translateObj"
            :element-author-display="elementAuthorDisplay"
            @close="closePanel"
            @changeTranslate="changeTranslate"
    >

        <template slot="t-description-text">
            업무정책 이벤트에 대한 반응 (subscribe)
        </template>

        <template slot="t-generation-text">
            Policies become the "Ports and Adaptors for Aggregate Root".
        </template>

        <template slot="t-edit-user">
            <div
                    v-if="newEditUserImg.length > 0 && readOnly"
                    style="text-align:center"
            >
                <v-chip
                        small
                        color="orange"
                        text-color="white"
                        style="font-weight:bold">
                    <v-avatar left>
                        <v-icon>mdi-lead-pencil</v-icon>
                    </v-avatar>
                    {{newEditUserImg[0].name}} is now editing...
                </v-chip>
            </div>
        </template>
    </common-panel>
</template>


<script>
    import CommonPanel from "./CommonPanel";
    import EventStormingModelPanel from "../EventStormingModelPanel";
    // Translate
    var googleTranslate = require('google-translate')(process.env.VUE_APP_TRANSLATE_KEY);
    var changeCase = require('change-case');

    export default {
        mixins: [EventStormingModelPanel],
        name: 'policy-panel',
        components: {
            CommonPanel
        },
        data() {
            return {

            }
        },
        computed: {

        },
        beforeDestroy() {
        },
        created: function () {
            this.panelInit()
        },
        watch: {},
        methods: {
            panelInit(){
                var me = this
                // Policy
                this.relatedUrl = 'https://intro-kor.msaez.io/tool/event-storming-tool/#%C2%B7-policy-sticker'

                // Common
                me.$super(EventStormingModelPanel).panelInit()
            },
            async changedNamePanel(newVal){
                var me = this
                me.canvasbase.$refs[`${me.value.elementView.id}`][0].namePanel = newVal

                var translateObj = await me.getTranslate(newVal);
                me.usedTranslate = translateObj.usedTranslate
                me.translateText = translateObj.translateText

            },
            getTranslate(newVal){
                try{
                    return new Promise(async function (resolve) {
                        googleTranslate.detectLanguage(newVal, function (err, detection) {
                            if (detection.language != 'en') {
                                googleTranslate.translate(newVal, 'en', function (err, translation) {
                                    var obj={
                                        'usedTranslate' : true,
                                        'translateText' : changeCase.pascalCase(translation.translatedText)
                                    }
                                    resolve(obj)
                                });
                            } else if (detection.language == 'en') {
                                var obj={
                                    'usedTranslate' : true,
                                    'translateText' : changeCase.pascalCase(newVal)
                                }
                                resolve(obj)
                            }
                        });
                    })
                }catch (e) {
                    return undefined;
                }
            },
        }
    }
</script>
